import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import { formatScheduleLine } from "helpers/reportSubscriptions";

const useStyles = makeStyles()(() => ({
	row: {
		fontSize: "13px",
		color: "#374151",
	},
	label: {
		fontWeight: 600,
		marginRight: "4px",
	},
}));

const SubscriptionScheduleDisplay = ({ subscription }) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	const line = formatScheduleLine(
		{
			frequency: subscription.frequency,
			days: subscription.daysOfWeek,
			time: subscription.timeOfDay,
			timezone: subscription.timezone,
		},
		t
	);
	return (
		<Typography className={classes.row}>
			<span className={classes.label}>{t("label.scheduleColon")}</span>
			{line}
		</Typography>
	);
};

export default SubscriptionScheduleDisplay;
